/**
 * Constants for submission activity processing and visualization
 */

// Spike Detection Configuration
export const SPIKE_DETECTION_DEFAULTS = {
	spikeThresholdMultiplier: 2.0,  // Spike if count > average * multiplier
	minimumSpikeCount: 5,           // Lower threshold for real data vs mock
	rollingWindowDays: 7            // Days to use for rolling average calculation
};

// API Configuration
export const API_DEFAULTS = {
	submissionFetchLimit: 1000,     // High limit to get all submissions in range
	cacheValidityMinutes: 5         // How long to consider cached data valid
};

// UI Configuration
export const UI_CONSTANTS = {
	heatmapBarMinHeight: 4,         // Minimum height for heatmap bars (px)
	heatmapBarMaxHeight: 60,        // Maximum height for heatmap bars (px)
	sparklineMinHeight: 2,          // Minimum height for sparkline bars (%)
	sparklineMaxHeight: 100,        // Maximum height for sparkline bars (%)
	defaultDaysRange: 30,           // Default number of days to display
	tooltipDelay: 200,              // Delay before showing tooltips (ms)
	refreshCooldown: 1000,          // Minimum time between refresh requests (ms)
	pollingInterval: 60000,         // Real-time polling interval (ms) - 60 seconds
	initialPollingDelay: 30000      // Initial delay before first poll (ms) - 30 seconds
};

// Date and Time Configuration
export const TIME_CONSTANTS = {
	millisecondsInDay: 24 * 60 * 60 * 1000,
	urgentRenewalDays: 7,
	upcomingRenewalDays: 30
};

// Color Intensity Thresholds for Heatmap
export const INTENSITY_THRESHOLDS = {
	veryLow: 20,    // 0-20% of max
	low: 40,        // 20-40% of max  
	medium: 60,     // 40-60% of max
	high: 80,       // 60-80% of max
	peak: 100       // 80-100% of max
};

// Status and Error Messages
export const ERROR_MESSAGES = {
	authRequired: 'Authentication required. Please log in again.',
	fetchFailed: 'Failed to fetch submission activity',
	noData: 'No submission data available',
	invalidData: 'Invalid submission data received'
};